const CalculoInteresesState = {
    messagesuccess: false,
    calculando: false,
    imprimiendo: false,
    dataIntereses: {},
    mensaje: "",
}

export default CalculoInteresesState;
